import { render, staticRenderFns } from "./updatePhoneNumber.vue?vue&type=template&id=16c5deec&scoped=true&"
import script from "./updatePhoneNumber.vue?vue&type=script&lang=js&"
export * from "./updatePhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./updatePhoneNumber.vue?vue&type=style&index=0&id=16c5deec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5deec",
  null
  
)

export default component.exports